<template>
  <section class="redirect">
    <div class="redirect__text">
      <h1
        class="heading"
        v-html="
          $t('REDIRECTION_IN_SECONDS', {
            seconds: timer,
          })
        "
      ></h1>
      <router-link to="/link"
        >{{ $t("WANT TO SKIP THIS?") }}
        {{ $t("LINK YOUR DEVICE TO APPDB") }}</router-link
      >
      <p class="text g-text" v-html="$t('STEVE_JOBS_QUOTE')"></p>
    </div>
    <img class="redirect__img" src="@/assets/redirect.svg" />
  </section>
</template>

<script>
export default {
  data() {
    return {
      timer: '∞',
    };
  },
  computed: {
    title() {
      return this.$t('REDIRECTING');
    },
  },
  methods: {
    redirect(ticket) {
      this.$api.getRedirectLink(ticket).then((response) => {
        window.location = response.link;
      });
    },
  },
  created() {
    this.$api.getRedirectParams(this.$route.params.ticket)
      .then((response) => {
        if (!response.wait) {
          this.redirect(response.redirection_ticket);
          return;
        }

        this.timer = response.wait;
        const interval = setInterval(() => {
          this.timer -= 1;
          if (!this.timer) {
            clearInterval(interval);
            this.redirect(response.redirection_ticket);
          }
        }, 1000);
      });
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.redirect {
  display: flex;

  @include notebook {
    flex-direction: column;
    align-items: center;
  }

  &__text {
    max-width: 450px;
    margin-right: 30px;

    @include notebook {
      margin-right: 0;
      margin-bottom: 30px;
    }
  }

  &__img {
    max-width: 100%;
  }
}

.heading {
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 7px;
}

.text {
  margin-top: 30px;
}
</style>
